module.exports = __webpack_public_path__ + "static/media/playlists.8f999c2f.svg";